import React from 'react'
import { Modal, ModalBody } from 'reactstrap'
// import circularIcon from "../../assets/images/partnerDashboard/logo/circularIcon.png"
import BNRathiLogoSide from "../../assets/images/BNRathiLogoSide.png";
import { useNavigate } from 'react-router-dom';
const PasswordResetSuccessModal = ({showModal,onCloseClick}) => {
  const navigate = useNavigate();
  return (
    <Modal isOpen={showModal?.show}
    //  toggle={onCloseClick}
      centered={true}>
        {/* <ModalHeader toggle={onCloseClick}></ModalHeader> */}
          <ModalBody className="p-5">
          <div className="mt-2 text-center">
              <img src={BNRathiLogoSide} alt='icon' />
              <div className="mt-4 pt-2">
                  <h3>Password Submission <br/> Successful</h3>
                  <p className=" mx-4 mt-3 mb-0 fs-p-sm">
                  You’ve successfully set a new password. You can now login with new password.
                  </p>
                  </div>
              </div>
              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <button
                  type="button"
                  className="btn w-sm btn-success"
                  data-bs-dismiss="modal"
                  onClick={()=>{
                    navigate('/login')
                  }}
              >
                  Ok, Got it.
              </button>
              
              </div>
      </ModalBody>
    </Modal>
  )
}

export default PasswordResetSuccessModal